import { useState } from "react";
import { Button, MetaInfo } from "../StyledElements";
import { Icon } from "@iconify/react";
import { removeCollaborator, makeHost } from "../../services/liveevents";
import { useSelector } from "react-redux";
import { useLiveEvents } from "../../contexts/LiveEventsContext";
import Swal from "sweetalert2";

export const CollaboratorCard = ({
  collaborator,
  allowChangeRole = false,
  showStatus = false,
  showRole = true,
  style = {},
  onAdmitCollaborator = () => { },
}) => {
  const token = useSelector((state) => state.users.token);
  const [makingHost, setMakingHost] = useState(false);
  const [admittingToEvent, setAdmittingToEvent] = useState(false);
  const { updatedEvent, setUpdatedEvent } = useLiveEvents();

  return (
    <div
      style={{
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        marginBottom: "10px",
      }}
    >
      <div
        style={{
          padding: "12px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          ...style,
        }}
      >
        <div style={{ fontWeight: 600, marginRight: 10 }}>
          {collaborator?.user && collaborator?.user?.firstname ? (
            <div>{collaborator.user.firstname} {collaborator.user.lastname}</div>
          ) : (
            <div>{collaborator.email}</div>
          )
          }
        </div>

        <div style={{ fontWeight: "600", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-end", gap: "4px", flexWrap: "wrap" }}>
          {showRole && (
            <MetaInfo>{collaborator.role[0].toUpperCase()}{collaborator.role.substr(1)}</MetaInfo>
          )}
          {
            allowChangeRole && (collaborator.role !== "host" && !collaborator.is_owner) ? (
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "4px" }}>
                <Button disabled={makingHost} style={{ height: "auto", borderRadius: "10px", padding: "2px 8px", fontSize: "14px" }} onClick={async () => {
                  setMakingHost(true);
                  console.log("!!! MAKING HOST: ", updatedEvent, collaborator);
                  const results = await makeHost(token, updatedEvent.public_id, collaborator.public_id);

                  if (results.success) {
                    const ue = { ...updatedEvent };
                    ue.collaborators = results.collaborators;
                    setUpdatedEvent(ue);
                  }

                  setMakingHost(false);
                }}>
                  {makingHost ? "Making Host" : "Make Host"}

                </Button>
                <div
                  alt="Remove Collaborator"
                  title="Remove Collaborator"
                  style={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", padding: "4px" }}
                  onClick={async () => {
                    Swal.fire({
                      title: "Are you sure?",
                      text: `This will remove ${collaborator?.user ? collaborator.user.firstname : collaborator.email_address} as a collaborator on this event.`,
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#d33",
                      cancelButtonColor: "#3085d6",
                      confirmButtonText: "Yes, remove!",
                    }).then(async (result) => {
                      if (result.value) {
                        console.log("!!! REMOVING COLLABORATOR: ", updatedEvent, collaborator);
                        const ue = { ...updatedEvent };
                        ue.collaborators = ue.collaborators.filter((c) => c.public_id !== collaborator.public_id);
                        setUpdatedEvent(ue);

                        const results = await removeCollaborator(token, updatedEvent.public_id, collaborator.public_id);
                        if (!results.success) {
                          Swal.fire("Error", "There was an error removing the collaborator. Please try again.", "error");
                        }
                      }
                    });
                  }}
                ><Icon icon="mdi:cancel" width="20" height="20" style={{ cursor: "pointer" }} onClick={() => { }} /></div>
              </div>
            ) : null
          }
        </div>
      </div>
      {
        showStatus && (
          <div style={{
            marginBottom: "10px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between"
          }}>
            < MetaInfo >
              {
                collaborator.status === "active" ? (
                  <span style={{ color: "green" }}>Online</span>
                ) :
                  collaborator.status === "admitted" ? (
                    <span style={{ color: "blue" }}>Admitted</span>
                  ) :
                    collaborator.status === "waiting" ?
                      (
                        <span style={{ color: "yellow" }}>Waiting</span>
                      ) : (
                        <span style={{ color: "red" }}>Offline</span>
                      )
              }
            </MetaInfo>
            {
              collaborator?.status === "waiting" && allowChangeRole && (
                <Button style={{ marginLeft: "10px", marginRight: "20px", height: "auto", borderRadius: "10px", padding: "2px 8px", width: "55px", fontSize: "14px" }} onClick={() => {
                  console.log("!!! ADMITTING COLLABORATOR: ", updatedEvent, collaborator);
                  setAdmittingToEvent(true);
                  onAdmitCollaborator(collaborator);
                }}>
                  {admittingToEvent ? "Admitting" : "Admit"}
                </Button>
              )
            }
          </div >
        )
      }
    </div >
  );
};

export default CollaboratorCard;
